export default __webpack_public_path__ + "static/media/house-7.9fb2b243.jpg";